import Metismenu from "metismenujs";
import React, {
  Component,
  useContext,
  useEffect,
  Fragment,
  useState,
} from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, Redirect } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import plus from "../../../images/plus.png";
/* @import url("https://cdn.sy");
 */
import { Calendar, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import addDays from "date-fns/addDays";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }

  componentWillUnmount() {}

  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const [isviewoutsid, setIsviewoutsid] = useState(
    JSON.parse(localStorage.getItem("userDetails")).role
  );
  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );

  const [todaymenuPopup, setTodaymenuPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateChange = (date) => {
    console.log(date, ">>>>>>>>>>>>>>>>>>>");
    setSelectedDate(date);
  };

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);

  useEffect(() => {
    setTodaymenuPopup(true);
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector(".heart");
    function heartBlast() {
      return handleheartBlast.classList.toggle("heart-blast");
    }
    //handleheartBlast.addEventListener('click', heartBlast);

    console.log("admintomanger", admintomanger);
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = [
      "",
      "CustomerList",
      "OrderList",
      "order-list",
      "order-details",
      "customers",
      "analytics",
      "review",
      "task",
    ],
    outlet = ["dashboard", "SlotMasterManagment", "OutletIndividualStafs"],
    menu = [
      "OutletFoodMenuListManagment",
      "FoodMenuListManagment",
      "MenuCategory",
      "OutletMenuPlanner",
      "DailyPlanner",
      "FreeDelivery",
      "Deliveryslot",
      "MenuSubMenuCategory",
      "OrderManagment",
    ],
    usersmenu = [
      "AdminManagment",
      "OwnerMasterList",
      "ManagerMasterList",
      "StaffMasterList",
      "CustomerStaffManagment",
      "OutletManagment",
      "DeliveryStaffManagment",
      "MenuCategory",
      "MenuSubMenuCategory",
    ],
    GeneralManagement = ["RoleManagement", "UserLogManagement"],
    Subscription = [
      "SubscriptionItem",
      "Subscribers",
      "Restarants",
      "DeliveryPointMaster",
      "wallet",
      "SubscriptionReports",
    ],
    Paymentmethods = ["ManagePaymentMethods", "OutletPaymentmethods"],
    CampainList = ["Campaign_Service","TemplateService","TemplateServiceList","Contact_master"],
    Template = [],
    app = [
      "app-profile",
      "CustomerManagment",
      "StaffManagment",
      "OutletManagment",
      "FoodMenuManagment",
      "OrderManagment",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-media-object",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
      "uc-lightgallery",
    ],
    redux = ["redux-form", "redux-wizard", "todo"],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];

  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll">
        <MM className="ai-icon" id="menu">
          {/* <li>
					<Link className={`${path === "dashboard-dark" ? "mm-active" : ""}`} to="/dashboard-dark"> 
						Dashboard Dark
					</Link>
				</li> */}
          {/* <li><Link className={`${path === "order-list" ? "mm-active" : ""}`} to="/order-list">Orders</Link></li>
              <li>
                <Link className={`${path === "order-details" ? "mm-active" : ""}`} to="/order-details">Order Details</Link>
              </li> */}

          {/* <li><Link className={`${path === "customers" ? "mm-active" : ""}`} to="/customers">Customers</Link></li>
              <li><Link className={`${path === "analytics" ? "mm-active" : ""}`} to="/analytics">Analytics</Link></li>
              <li><Link className={`${path === "review" ? "mm-active" : ""}`} to="/review">Review</Link></li>
              <li><Link className={`${path === "task" ? "mm-active" : ""}`} to="/task">Task</Link></li> */}

          {/* {(isviewoutsid == "MANAGER") && */}
          {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            // {(isviewoutsid == "MANAGER" || (isviewoutsid == "ADMIN" && admintomanger != null)) &&
            // <li className={`${deshBoard.includes(path) ? "mm-active" : "dashboard"}`}>
            <li className={`${path === "dashboard" ? "mm-active" : ""}`}>
              <Link to="/dashboard" className="ai-icon">
                <i className="flaticon-013-checkmark"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Outlet Profile
                </span>
              </Link>
            </li>
          )}

          {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li className={`${outlet.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Outlet</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${path === "dashboard" ? "mm-active" : ""}`}
                    to="/dashboard"
                  >
                    Outlet Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "SlotMasterManagment" ? "mm-active" : ""
                    }`}
                    to="/SlotMasterManagment"
                  >
                    Outlet Slot Timing
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "OutletIndividualStafs" ? "mm-active" : ""
                    }`}
                    to="/OutletIndividualStafs"
                  >
                    Outlet Staffs
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li className={`${menu.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Menu</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "FoodMenuListManagment" ? "mm-active" : ""
                    }`}
                    to="/FoodMenuListManagment"
                  >
                    Menu List
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${path === "MenuCategory" ? "mm-active" : ""}`}
                    to="/MenuCategory"
                  >
                    Menu Category
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "OrderManagment" ? "mm-active" : ""
                    }`}
                    to="/OrderManagment"
                  >
                    Menu Planner
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li
              className={`${path === "SlotMasterManagment" ? "mm-active" : ""}`}
            >
              <Link to="/SlotMasterManagment" className="ai-icon">
                <i className="flaticon-087-stop"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Outlet Slot Timing
                </span>
              </Link>
            </li>
           )} */}

          {/* {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li
              className={`${
                path === "OutletIndividualStafs" ? "mm-active" : ""
              }`}
            >
              <Link to="/OutletIndividualStafs" className="ai-icon">
                <i className="flaticon-017-clipboard"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Outlet Staffs
                </span>
              </Link>
            </li>
           )} */}

          {/* {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li
              className={`${
                path === "FoodMenuListManagment" ? "mm-active" : ""
              }`}
            >
              <Link to="/FoodMenuListManagment" className="ai-icon">
                <i className="flaticon-022-copy"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Menu
                </span>
              </Link>
             </li>
           )} */}

          {/*  {(isviewoutsid == "MANAGER" ||
            (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li className={`${path === "MenuCategory" ? "mm-active" : ""}`}>
              <Link to="/MenuCategory" className="ai-icon">
                <i className="flaticon-022-copy"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Menu Category
                </span>
              </Link>
            </li>
           )} */}

          {/* {isviewoutsid == "ADMIN" && */}
          {isviewoutsid == "ADMIN" && admintomanger == null && (
            // <li className={`${deshBoard.includes(path) ? "mm-active" : "SuperAdminDashboard"}`}>
            <li
              className={`${path === "SuperAdminDashboard" ? "mm-active" : ""}`}
            >
              <Link to="/SuperAdminDashboard" className="ai-icon">
                <i className="flaticon-025-dashboard"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Dashboard
                </span>
              </Link>
            </li>
          )}

          {/* {isviewoutsid == "ADMIN" && admintomanger == null && (
             <li className={`${path === "OutletManagment" ? "mm-active" : ""}`}>
              <Link to="/OutletManagment" className="ai-icon">
                <i className="flaticon-013-checkmark"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Outlet
                </span>
              </Link>
            </li>
           )} */}

          {/* {isviewoutsid == "MANAGER" && (
            <li className={`${path === "OrderManagment" ? "mm-active" : ""}`}>
              <Link to="/OrderManagment" className="ai-icon">
                <i className="flaticon-087-stop"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Menu Planner
                </span>
              </Link>
            </li>
           )} */}

          {/*  {(isviewoutsid == "MANAGER" ||
             (isviewoutsid == "ADMIN" && admintomanger != null)) && (
            <li className={`${path === "CustomerList" ? "mm-active" : ""}`}>
              <Link to="/CustomerList" className="ai-icon">
                <i className="flaticon-022-copy"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Customer
                </span>
              </Link>
            </li>
           )} 
           */}
          {isviewoutsid == "MANAGER" && (
            <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-041-graph"></i>
                <span className="nav-text">OMS</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${path === "CustomerList" ? "mm-active" : ""}`}
                    to="/CustomerList"
                  >
                    Customer
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${path === "OrderList" ? "mm-active" : ""}`}
                    to="/OrderList"
                  >
                    Order
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* {(isviewoutsid == "MANAGER") &&
            <li className={`${path === "MenuAvailablity" ? "mm-active" : ""}`}>
              <Link to="/MenuAvailablity" className="ai-icon" >
                <i className="flaticon-087-stop"></i>
                <span className="nav-text" style={{ fontFamily: "inherit", fontSize: "large" }}>Menu Availablity</span>
              </Link>
            </li>} */}

          {isviewoutsid == "STAFF" && admintomanger == null && (
            <li className={`${path === "EcommerceMnt" ? "mm-active" : ""}`}>
              <Link to="/EcommerceMnt" className="ai-icon">
                <i className="flaticon-017-clipboard"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Orders
                </span>
              </Link>
            </li>
          )}
          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li className={`${usersmenu.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Users</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "AdminManagment" ? "mm-active" : ""
                    }`}
                    to="/AdminManagment"
                  >
                    Admin
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "OwnerMasterList" ? "mm-active" : ""
                    }`}
                    to="/OwnerMasterList"
                  >
                    Owner
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "ManagerMasterList" ? "mm-active" : ""
                    }`}
                    to="/ManagerMasterList"
                  >
                    Manager
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "StaffMasterList" ? "mm-active" : ""
                    }`}
                    to="/StaffMasterList"
                  >
                    Staff
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "CustomerStaffManagment" ? "mm-active" : ""
                    }`}
                    to="/CustomerStaffManagment"
                  >
                    Customer
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "DeliveryStaffManagment" ? "mm-active" : ""
                    }`}
                    to="/DeliveryStaffManagment"
                  >
                    Driver
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li className={`${usersmenu.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Restaurants</span>
              </Link>
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "OutletManagment" ? "mm-active" : ""
                    }`}
                    to="/OutletManagment"
                  >
                    Manage Outlet
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "OutletFoodMenuListManagment" ? "mm-active" : ""
                    }`}
                    to="/OutletFoodMenuListManagment"
                  >
                    Manage Menu
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "MenuSubMenuCategory" ? "mm-active" : ""
                    }`}
                    to="/MenuSubMenuCategory"
                  >
                    Manage Category
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "OutletMenuPlanner" ? "mm-active" : ""
                    }`}
                    to="/OutletMenuPlanner"
                  >
                    Manage Menu Planner
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "DeliveryPointMaster" ? "mm-active" : ""
                    }`}
                    to="/DeliveryPointMaster"
                  >
                    Delivery Point
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${path === "Deliveryslot" ? "mm-active" : ""}`}
                    to="/Deliveryslot"
                  >
                    Delivery Slot
                  </Link>
                </li>

                {/* <li>
                  <Link
                    className={`${path === "DailyPlanner" ? "mm-active" : ""
                      }`}
                    to="/DailyPlanner"
                  >
                    Daily Planner  
                  </Link>
                </li> */}

                {/* <li>
                  <Link
                    className={`${path === "FreeDelivery" ? "mm-active" : ""
                      }`}
                    to="/FreeDelivery"
                  >
                  Free Delivery 
                  </Link>
                </li> */}
              </ul>
            </li>
          )}

          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li className={`${Subscription.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Subscription</span>
              </Link>

              {/* 
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text" style={{ fontFamily: "Roboto !important", fontSize: "small" }}>Subscription</span>
              </Link> */}
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "SubscriptionReports" ? "mm-active" : ""
                    }`}
                    to="/SubscriptionReports"
                  >
                    Subscription Report
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${
                      path === "SubscribersMaster" ? "mm-active" : ""
                    }`}
                    to="/SubscribersMaster"
                  >
                    Subscription Customer
                  </Link>
                </li>

                {/* <li>
                  <Link
                    className={`${path === "SubscriptionItemMaster" ? "mm-active" : ""
                      }`}
                    to="/SubscriptionItemMaster"
                  >
                  SubscriptionItem
                  </Link>
                </li> */}

                {/* <li>
                  <Link
                    className={`${path === "RestarantsMaster" ? "mm-active" : ""
                      }`}
                    to="/RestarantsMaster"
                  >
                  Restarants
                  </Link>
                </li> */}

                <li>
                  <Link
                    className={`${path === "WalletMaster" ? "mm-active" : ""}`}
                    to="/WalletMaster"
                  >
                    Wallet
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li
              className={`${Paymentmethods.includes(path) ? "mm-active" : ""}`}
            >
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">Payment Methods</span>
              </Link>
              {/* <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text" style={{ fontFamily: "Roboto !important", fontSize: "small" }}>
                  Payment Methods </span>
              </Link> */}
              <ul>
                {/* <li>
                  <Link
                    className={`${path === "ManagePaymentMethods" ? "mm-active" : ""
                      }`}
                    to="/ManagePaymentMethods"
                  >
                    Payment Methods
                  </Link>
                </li> */}

                <li>
                  <Link
                    className={`${
                      path === "OutletPaymentmethods" ? "mm-active" : ""
                    }`}
                    to="/OutletPaymentmethods"
                  >
                    Restaurant Payment Methods
                  </Link>
                </li>

                {/* <li>
                  <Link
                    className={`${path === "UserLogManagement" ? "mm-active" : ""
                      }`}
                    to="/UserLogManagement"
                  >
                    Razorpay
                  </Link>
                </li> */}
              </ul>
            </li>
          )}

          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li className={`${CampainList.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">WhatsApp</span>
              </Link>
              <ul>
                {/* <li>
                  <Link
                    className={`${path === "Campaign" ? "mm-active" : ""}`}
                    // to="/Campaign"
                    to="/CampaignSteper"
                  >
                    Broadcast
                  </Link>
                </li> */}
                <li>
                  <Link
                    className={`${
                      path === "Campaign_Service" ? "mm-active" : ""
                    }`}
                    to="/Campaign_Service"
                  >
                    Broadcast
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "TemplateService" ? "mm-active" : ""
                    }`}
                    to="TemplateService"
                  >
                   Create Template
                  </Link>
                </li>

                <li>
                  <Link
                    className={`${path === "TemplateServiceList" ? "mm-active" : ""
                      }`}
                    to="TemplateServiceList"
                  >
                    Template List
                  </Link>
                </li>
                  <li>
                  <Link
                    className={`${path === "Contact_master" ? "mm-active" : ""
                      }`}
                    to="/Contact_master"
                  >
                   Contact Master
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {isviewoutsid == "ADMIN" && admintomanger == null && (
            <li
              className={`${
                GeneralManagement.includes(path) ? "mm-active" : ""
              }`}
            >
              {/* 
<Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text">General Management</span>
              </Link>  */}
              {/* <Link className="has-arrow ai-icon" to="#">
                <i className="flaticon-022-copy"></i>
                <span className="nav-text" style={{ fontFamily: "Roboto !important", fontSize: "small" }}>General Management</span>
              </Link> */}
              <ul>
                <li>
                  <Link
                    className={`${
                      path === "UserLogManagement" ? "mm-active" : ""
                    }`}
                    to="/UserLogManagement"
                  >
                    Users Log
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "OrderLogManagement" ? "mm-active" : ""
                    }`}
                    to="/OrderLogManagement"
                  >
                    Order Log
                  </Link>
                </li>
                <li>
                  <Link
                    className={`${
                      path === "RoleManagement" ? "mm-active" : ""
                    }`}
                    to="/RoleManagement"
                  >
                    Role Managment
                  </Link>
                </li>
              </ul>
            </li>
          )}

          {/* {isviewoutsid == "STAFF" && admintomanger == null && (
            <li className={`${path === "orderCard" ? "mm-active" : ""}`}>
              <Link to="/orderCard" className="ai-icon">
                <i className="flaticon-017-clipboard"></i>
                <span
                  className="nav-text"
                  style={{ fontFamily: "inherit", fontSize: "large" }}
                >
                  Orders
                </span>
              </Link>
            </li>
          )} */}

          {/* {(isviewoutsid == "MANAGER") && */}

          {/* 
          {(isviewoutsid == "MANAGER") &&
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Calendar
                  date={selectedDate}
                  onChange={handleDateChange}
                  maxDate={addDays(new Date(), 6)}
                  minDate={new Date()}
                ></Calendar>
              </MuiPickersUtilsProvider>
            </div>
          } */}

          {/* <Redirect to pathname="/OrderManagment" render={(props) => <Calendar state = { selectedDate } date={selectedDate}onChange={handleDateChange} />} />
              <Redirect to pathname="/OrderManagment" render={(props) => <Calendar {...props} />}/> */}
          {/* <Redirect
                to={{
                  pathname: "/OrderManagment",
                  state: { selectedDate },
                }}
              /> */}

          {/* <li className={`${app.includes(path) ? "mm-active" : ""}`}>
          <Link className="has-arrow ai-icon" to="#" >
            <i className="flaticon-017-clipboard"></i>
            <span className="nav-text" style={{ fontFamily: "Poppins" }}>Managment</span>
          </Link>
          <ul >
            <li><Link className={`${path === "OutletManagment" ? "mm-active" : ""}`}
              to="/OutletManagment">Outlet</Link></li>

            <li><Link className={`${path === "StaffManagment" ? "mm-active" : ""}`}
              to="/StaffManagment">Staff</Link></li>

            <li><Link className={`${path === "FoodMenuManagment" ? "mm-active" : ""}`}
              to="/FoodMenuManagment">Menu</Link></li>

            <li><Link className={`${path === "OrderManagment" ? "mm-active" : ""}`}
              to="/OrderManagment">OMS</Link></li>


            {/* <li><Link className={`${path === "CustomerManagment" ? "mm-active" : ""}`}
                to="/CustomerManagment">Customer</Link></li> */}

          {/* <li><Link className={`${path === "app-profile" ? "mm-active" : ""}`}
                to="/app-profile">Profile</Link></li> */}

          {/* <li><Link className={`${path === "post-details" ? "mm-active" : ""}`}
                to="/post-details">Post Details</Link></li> */}

          {/* 
              <li className={`${email.includes(path) ? "mm-active" : ""}`}><Link className="has-arrow" to="#" >Email</Link>
                <ul className={`${email.includes(path) ? "mm-show" : ""}`}>
                  <li><Link className={`${path === "email-compose" ? "mm-active" : ""}`} to="/email-compose">Compose</Link></li>
                  <li><Link className={`${path === "email-inbox" ? "mm-active" : ""}`} to="/email-inbox">Inbox</Link></li>
                  <li><Link className={`${path === "email-read" ? "mm-active" : ""}`} to="/email-read">Read</Link></li>
                </ul>
              </li>
              <li><Link className={`${path === "app-calender" ? "mm-active" : ""}`} to="/app-calender">Calendar</Link></li>
              <li className={`${shop.includes(path) ? "mm-active" : ""}`}><Link className="has-arrow" to="#" >Shop</Link>
                <ul className={`${shop.includes(path) ? "mm-show" : ""}`}>
                  <li><Link className={`${path === "ecom-product-grid" ? "mm-active" : ""}`} to="/ecom-product-grid">Product Grid</Link></li>
                  <li><Link className={`${path === "ecom-product-list" ? "mm-active" : ""}`} to="/ecom-product-list">Product List</Link></li>
                  <li><Link className={`${path === "ecom-product-detail" ? "mm-active" : ""}`} to="/ecom-product-detail">Product Details</Link></li>
                  <li><Link className={`${path === "ecom-product-order" ? "mm-active" : ""}`} to="/ecom-product-order">Order</Link></li>
                  <li><Link className={`${path === "ecom-checkout" ? "mm-active" : ""}`} to="/ecom-checkout">Checkout</Link></li>
                  <li><Link className={`${path === "ecom-invoice" ? "mm-active" : ""}`} to="/ecom-invoice">Invoice</Link></li>
                  <li><Link className={`${path === "ecom-customers" ? "mm-active" : ""}`} to="/ecom-customers">Customers</Link></li>
                </ul>
              </li> */}
          {/* </ul>
        </li> */}

          {/* <li className={`${charts.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-041-graph"></i>
              <span className="nav-text">Charts</span>
            </Link>
            <ul >
              <li>
                <Link
                  className={`${path === "chart-rechart" ? "mm-active" : ""}`}
                  to="/chart-rechart"
                >
                  RechartJs
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-chartjs" ? "mm-active" : ""}`}
                  to="/chart-chartjs"
                >
                  Chartjs
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-chartist" ? "mm-active" : ""}`}
                  to="/chart-chartist"
                >
                  Chartist
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-sparkline" ? "mm-active" : ""}`}
                  to="/chart-sparkline"
                >
                  Sparkline
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-apexchart" ? "mm-active" : ""}`}
                  to="/chart-apexchart"
                >
                  Apexchart
                </Link>
              </li>
            </ul>
          </li> */}
          {/* <li className={`${bootstrap.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-086-star"></i>
              <span className="nav-text">Bootstrap</span>
            </Link>
            <ul >
              <li>
                <Link
                  className={`${path === "ui-accordion" ? "mm-active" : ""}`}
                  to="/ui-accordion"
                >
                  Accordion
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-alert" ? "mm-active" : ""}`}
                  to="/ui-alert"
                >
                  Alert
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-badge" ? "mm-active" : ""}`}
                  to="/ui-badge"
                >
                  Badge
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-button" ? "mm-active" : ""}`}
                  to="/ui-button"
                >
                  Button
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-modal" ? "mm-active" : ""}`}
                  to="/ui-modal"
                >
                  Modal
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-button-group" ? "mm-active" : ""}`}
                  to="/ui-button-group"
                >
                  Button Group
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-list-group" ? "mm-active" : ""}`}
                  to="/ui-list-group"
                >
                  List Group
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-card" ? "mm-active" : ""}`}
                  to="/ui-card"
                >
                  Cards
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-carousel" ? "mm-active" : ""}`}
                  to="/ui-carousel"
                >
                  Carousel
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-dropdown" ? "mm-active" : ""}`}
                  to="/ui-dropdown"
                >
                  Dropdown
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-popover" ? "mm-active" : ""}`}
                  to="/ui-popover"
                >
                  Popover
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-progressbar" ? "mm-active" : ""}`}
                  to="/ui-progressbar"
                >
                  Progressbar
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-tab" ? "mm-active" : ""}`}
                  to="/ui-tab"
                >
                  Tab
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-typography" ? "mm-active" : ""}`}
                  to="/ui-typography"
                >
                  Typography
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-pagination" ? "mm-active" : ""}`}
                  to="/ui-pagination"
                >
                  Pagination
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-grid" ? "mm-active" : ""}`}
                  to="/ui-grid"
                >
                  Grid
                </Link>
              </li>
            </ul>
          </li> */}
          {/* <li className={`${plugins.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-045-heart"></i><span className="nav-text">Plugins</span>
            </Link>
            <ul >
              <li><Link className={`${path === "uc-select2" ? "mm-active" : ""}`} to="/uc-select2">Select 2</Link></li>
              <li><Link className={`${path === "uc-nestable" ? "mm-active" : ""}`} to="/uc-nestable">Nestedable</Link></li>
              <li><Link className={`${path === "uc-noui-slider" ? "mm-active" : ""}`} to="/uc-noui-slider">Noui Slider</Link></li>
              <li><Link className={`${path === "uc-sweetalert" ? "mm-active" : ""}`} to="/uc-sweetalert">Sweet Alert</Link></li>
              <li><Link className={`${path === "uc-toastr" ? "mm-active" : ""}`} to="/uc-toastr">Toastr</Link></li>
              <li><Link className={`${path === "map-jqvmap" ? "mm-active" : ""}`} to="/map-jqvmap">Jqv Map</Link></li>
              <li><Link className={`${path === "uc-lightgallery" ? "mm-active" : ""}`} to="/uc-lightgallery">Light Gallery</Link></li>
            </ul>
          </li> */}
          {/* <li className={`${redux.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-087-stop"></i><span className="nav-text">Redux</span>
            </Link>
            <ul>
              <li><Link className={`${path === "todo" ? "mm-active" : ""}`} to="/todo">Todo</Link></li>
              <li><Link className={`${path === "redux-form" ? "mm-active" : ""}`} to="/redux-form">Redux Form</Link></li>
              <li><Link className={`${path === "redux-wizard" ? "mm-active" : ""}`} to="/redux-wizard">Redux Wizard</Link></li>
            </ul>
          </li> */}
          {/* <li className={`${widget.includes(path) ? "mm-active" : ""}`}>
            <Link to="widget-basic" className="ai-icon" >
              <i className="flaticon-013-checkmark"></i>
              <span className="nav-text">Widget</span>
            </Link>
          </li> */}
          {/* <li className={`${forms.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-072-printer"></i>
              <span className="nav-text forms">Forms</span>
            </Link>
            <ul >
              <li>
                <Link
                  className={`${path === "form-element" ? "mm-active" : ""}`}
                  to="/form-element"
                >
                  Form Elements
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-wizard" ? "mm-active" : ""}`}
                  to="/form-wizard"
                >
                  Wizard
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-editor-summernote" ? "mm-active" : ""
                    }`}
                  to="/form-editor-summernote"
                >
                  Summernote
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-pickers" ? "mm-active" : ""}`}
                  to="/form-pickers"
                >
                  Pickers
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-validation-jquery" ? "mm-active" : ""
                    }`}
                  to="/form-validation-jquery"
                >
                  Form Validate
                </Link>
              </li>
            </ul>
          </li> */}
          {/* <li className={`${table.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" ><i className="flaticon-043-menu"></i><span className="nav-text">Table</span></Link>
            <ul>
              <li>
                <Link className={`${path === "table-filtering" ? "mm-active" : ""}`} to="/table-filtering">
                  Table Filtering
                </Link>
              </li>
              <li>
                <Link className={`${path === "table-sorting" ? "mm-active" : ""}`} to="/table-sorting">
                  Table Sorting
                </Link>
              </li>
              <li>
                <Link className={`${path === "table-bootstrap-basic" ? "mm-active" : ""}`} to="/table-bootstrap-basic">
                  Bootstrap
                </Link>
              </li>
              <li>
                <Link className={`${path === "table-datatable-basic" ? "mm-active" : ""}`} to="/table-datatable-basic">
                  Datatable
                </Link>
              </li>
            </ul>
          </li> */}
          {/* <li className={`${pages.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" >
              <i className="flaticon-022-copy"></i>
              <span className="nav-text">Pages</span>
            </Link>
            <ul >
              <li className={`${error.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" >Error</Link>
                <ul>
                  <li><Link className={`${path === "page-error-400" ? "mm-active" : ""}`} to="/page-error-400">Error 400</Link></li>
                  <li><Link className={`${path === "page-error-403" ? "mm-active" : ""}`} to="/page-error-403">Error 403</Link></li>
                  <li><Link className={`${path === "page-error-404" ? "mm-active" : ""}`} to="/page-error-404">Error 404</Link></li>
                  <li><Link className={`${path === "page-error-500" ? "mm-active" : ""}`} to="/page-error-500">Error 500</Link></li>
                  <li><Link className={`${path === "page-error-503" ? "mm-active" : ""}`} to="/page-error-503">Error 503</Link></li>
                </ul>
              </li>
              <li>
                <Link
                  className={`${path === "page-lock-screen" ? "mm-active" : ""
                    }`}
                  to="/page-lock-screen"
                >
                  Lock Screen
                </Link>
              </li>
            </ul>
          </li> */}
        </MM>
        {/* <div className="plus-box">
			<img src={plus} alt="" />
			<h5 className="fs-18 font-w700">Add Menus</h5>
			<p className="fs-14 font-w400">Manage your food <br />and beverages menus<i className="fas fa-arrow-right ms-3"></i></p>
		</div> */}

        <div className="copyright">
          {/* <p><strong>FIS Restaurant Admin</strong> 
           © 2021 All Rights Reserved</p> */}
          {/* <p className="fs-12">Made with <span className="heart"></span> by Client Linx Software Pvt Ltd</p> */}
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
